import * as API from './index'

export default {
    getList: params => {
        return API.GET('/api/Match/List', params)
    },
    get: params => {
        return API.GET('/api/Match/Get', params)
    },
    add: params => {
        return API.POST('/api/Match/Add', params)
    },
    adminAdd: params => {
        return API.POST('/api/Match/AdminAdd', params)
    },
    edit: params => {
        return API.POST('/api/Match/Edit', params)
    },
    delete: params => {
        return API.DELETE('/api/Match/Delete', params)
    },
    deletebatch: params => {
        return API.DELETE('/api/Match/DeleteBatch', params)
    }, searchMatch: params => {
        return API.GET('/api/Match/SearchMatch', params)
    },
    joinMatch: params => {
        return API.POST('/api/Match/JoinMatch', params)
    },
    summary: params => {
        return API.GET('/api/Match/Summary', params)
    },
    setRebateStatus: params => {
        return API.GET('/api/Match/SetRebateStatus', params)
    },
    authHost:params=>{
        return API.POST('/api/MatchHost/Add', params)
    },
    upload: params => {
        return API.POSTFORM('/api/Upload/Post', params)
    },
    loadCategory:params=>{
        return API.GET('/api/match/LoadCategory',params);
    }
}


// WEBPACK FOOTER //
// ./src/apis/match.js